var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNothingToSeeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 21.6003H5.39999C4.0745 21.6003 2.99999 20.5258 3 19.2003L3.00009 4.80038C3.0001 3.4749 4.07462 2.40039 5.40009 2.40039H16.2004C17.5258 2.40039 18.6004 3.47491 18.6004 4.80039V9.60039M19.8 19.8004L21 21.0004M7.20037 7.20039H14.4004M7.20037 10.8004H14.4004M7.20037 14.4004H10.8004M20.4 17.4004C20.4 19.0572 19.0569 20.4004 17.4 20.4004C15.7431 20.4004 14.4 19.0572 14.4 17.4004C14.4 15.7435 15.7431 14.4004 17.4 14.4004C19.0569 14.4004 20.4 15.7435 20.4 17.4004Z",
    stroke: "#0A090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingToSeeIcon);
export default __webpack_public_path__ + "static/media/nothingToSeeIcon.45d44f3dbd918df99393e820daa5320f.svg";
export { ForwardRef as ReactComponent };